let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iaEBn")).then(() => parcelRequire('eV9zo'));